// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u5x4AAkRS6kCrljEVmQy {
  margin-left: 12.375rem;
  margin-top: 1.875rem;
  list-style: none;
  padding: 0;
}

.gf2ASgGJuT9lSxlfAdL8 {
  margin-left: 0;
  margin-top: 0;
  flex-shrink: 0;
}

.t7rioczomclUyJq_eUBQ {
  padding: 0.125rem 0;
}

.KAsrSXEd7me2KDbM8g6r {
  margin-right: 0.75rem;
  width: 1.25rem;
  height: 1.25rem;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .u5x4AAkRS6kCrljEVmQy {
    margin-left: 23rem;
  }

  .gf2ASgGJuT9lSxlfAdL8 {
    margin-left: 0;
  }
}

@media only screen and
  (max-width: 639px) {
  .u5x4AAkRS6kCrljEVmQy {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PdpUsps/PdpUsps.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAkB;EAClB,oBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAc;AAChB;;AAEA;EACE,qBAAkB;EAClB,cAAW;EACX,eAAY;AACd;;AAEA;;;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".pdpUsps {\n  margin-left: 198px;\n  margin-top: 30px;\n  list-style: none;\n  padding: 0;\n}\n\n.pdpUspsModal {\n  margin-left: 0;\n  margin-top: 0;\n  flex-shrink: 0;\n}\n\n.pdpUspsItem {\n  padding: 2px 0;\n}\n\n.icon {\n  margin-right: 12px;\n  width: 20px;\n  height: 20px;\n}\n\n@media (--tablet) {\n  .pdpUsps {\n    margin-left: 368px;\n  }\n\n  .pdpUspsModal {\n    margin-left: 0;\n  }\n}\n\n@media (--mobile) {\n  .pdpUsps {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pdpUsps": `u5x4AAkRS6kCrljEVmQy`,
	"pdpUspsModal": `gf2ASgGJuT9lSxlfAdL8`,
	"pdpUspsItem": `t7rioczomclUyJq_eUBQ`,
	"icon": `KAsrSXEd7me2KDbM8g6r`
};
export default ___CSS_LOADER_EXPORT___;
